import { List, Map } from 'immutable'

export const QTY_SELECT = [...Array(50)].reduce(
  (prev, _cur, i) => prev.push(Map({ value: i + 1, text: i + 1 })),
  List([])
)
export const QTY_BIG_SELECT = [...Array(999)].reduce(
  (prev, _cur, i) => prev.push(Map({ value: i + 1, text: i + 1 })),
  List([])
)

export const formatPrice = (price, priceMask, noRound) =>
  price != null && price != undefined && price.toFixed
    ? priceMask.replace(
        '{{price}}',
        '<ins>' +
          price.toFixed(2).split('.')[0] +
          '</ins>' +
          '<sub>' +
          (!noRound && price >= 100 ? '' : '.' + price.toFixed(2).split('.')[1]) +
          '</sub>'
      )
    : '---'

export const replacePackage = item =>
  item.get('amount_per_item')
    ? item.get('amount_per_item') + ' ' + item.get('amount_per_item') > 1
      ? item.get('unit_plural')
      : item.get('unit')
    : ''

export const getTotal = (answerModel, item) =>
  answerModel
    .get('answers')
    .reduce(
      (prev, cur) =>
        item && item.get('id') == cur.get('id')
          ? prev
          : cur.get('count') * (cur.getIn(['item', 'discounted_price']) || cur.getIn(['item', 'price'])) + prev,
      0
    )

export const getMaxProductCount = answerModel =>
  answerModel.get('answers').reduce((prev, cur) => (cur.get('count') > prev ? cur.get('count') : prev), 0)

export const getMaxPrice = answerModel =>
  answerModel
    .get('answers')
    .reduce(
      (prev, cur) =>
        (cur.getIn(['item', 'discounted_price']) || cur.getIn(['item', 'price'])) > prev
          ? cur.getIn(['item', 'discounted_price']) || cur.getIn(['item', 'price'])
          : prev,
      0
    )

export const getSize = (answerModel, item) =>
  answerModel
    .get('answers')
    .reduce((sum, c) => (item && item.get('id') == c.getIn(['item', 'id']) ? sum : sum + c.get('count')), 0)

// Per-image rembg eligibility (AYTM-12823): the image's own flag, with a backward-compat fallback
// to the product `external` flag for survey schemas cached before per-image rembg shipped. Nullish
// (??), never ||, so a new-schema rembg===false (manual upload) isn't overridden by a truthy external.
//
// REMOVAL: drop the `?? answer.get('external')` fallback (leaving just `image.get('rembg')`) once
// this has been live in production longer than the swidget schema cache TTL (24h) — by then every
// cached survey schema carries `image.rembg`, the fallback is dead, and `external` becomes truly
// unread, which unblocks fully removing the flag (the separate cleanup ticket noted in the task doc).
export const imageRembg = (image, answer) => (image ? image.get('rembg') : undefined) ?? answer.get('external')
